import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { IDisplayAdsFormatFilterDto } from "../../types/leadsSearchFilters.dto";

export type DisplayAdsFormatFilterDescription = {
    readonly displayAdsShare: readonly number[];
};
export default class FindDisplayAdsFormatFilter extends FilterPanelBaseFilter<
    IDisplayAdsFormatFilterDto,
    DisplayAdsFormatFilterDescription
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IDisplayAdsFormatFilterDto, DisplayAdsFormatFilterDescription>) {
        super(deps);
    }

    isFilterDirty(currentValue: IDisplayAdsFormatFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }

    calculateValueDelta(
        previousValue: IDisplayAdsFormatFilterDto | undefined,
        newValue: IDisplayAdsFormatFilterDto | undefined,
    ): FilterValueDelta<IDisplayAdsFormatFilterDto> {
        return calculateObjectValueDelta<Partial<IDisplayAdsFormatFilterDto>>(previousValue, newValue);
    }
}
